
import { DatePipe, JsonPipe } from '@angular/common'
import { CreateTicketFormFields } from '../tickets/createTicketFormFields'
import { TicketsService, EquipmentService } from '../../services/'
import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class BartTicketSummary {
    datePiepe = new DatePipe('en-US')
    private formFields: CreateTicketFormFields;
    constructor(private _ticketService: TicketsService, private _equipmentService: EquipmentService) {

        this._ticketService.getTicketGlobalData().subscribe((Result: any) => {
            this.formFields = Result; //Get Latest Update value from here
        },
            (error) => {
                // handle error here
            }
        );
    }
    public populateTicketSummary() {
        var i = 0;
        var varname = 'placeholder';
        var ticketNumber = this.formFields.TicketId
        var totalHours = this.formFields.totalHours + this.formFields.totalMinutes;
        var rowHTML = "";
        var partTotal = 0;
        var lineTotal = 0;
        var partCount = 0;

        // var serviceType = '';
        // $("#workTypeId option").each(function (i) {
        //     if ($(this).attr('selected')) {
        //         serviceType = this.innerHTML;
        //     }
        // });

        // $('#tsDivision').html($('#divisionMasterId :selected').text());
        // $('#tsFacility').html($('#facilityMasterId :selected').text());
        // $('#tsDateRequested').html($('#dateServiceRequested').val());
        // $('#tsServiceType').html(serviceType);
        // $('#tsDateBegan').html($('#dateServiceBegan').val());
        // $('#tsTicketNum').html(ticketNumber);
        // $('#tsActualDate').html($('#dateServicePerformed').val());
        // $('#tsDateClosed').html(CURRENTDATE);
        // $('#tsEquipment').html($('#equipmentTypeDescription').html());
        // $('#tsLaborTime').html($('#hoursWork').val());
        // $('#tsManufacturer').html($('#manufacturerName').html());
        // $('#tsTravelTime').html($('#hoursTravel').val());
        // $('#tsModel').html($('#modelDescription').html());
        // $('#tsTotalTime').html(totalHours);
        // $('#tsSerial').html($('#equipmentSerialNumber').html());
        // $('#tsMachineHours').html($('#clockHours').val());
        // $('#tsServReq').html($('#serviceRequested').val());
        // $('#tsFindings').html($('#findings').val());
        // $('#tsWorkPerf').html($('#workPerformed').val());
        // $("#tickSumPartsTable").find("tr:gt(0)").remove();

        // rowHTML = "";
        // tickPartSummary = buildPartsSummary(1, 'ts');
        // partCount = tickPartSummary.partCount;
        // rowHTML = tickPartSummary.html;

        // if (partCount == 0) {
        //     $('#tickSumPartsTable').hide();
        // } else {
        //     $('#tickSumPartsTable').show().html(rowHTML);
        // }

        // // TEST EQUIP	
        // rowHTML = "";
        // tickTestEquipSummary = buildTestEquipSummary(1, 'ts');
        // testEquipCount = tickTestEquipSummary.testEquipCount;
        // rowHTML = tickTestEquipSummary.html;

        // if (testEquipCount == 0) {
        //     $('#tickSumTestEquipTable').hide();
        // } else {
        //     $('#tickSumTestEquipTable').show().html(rowHTML);
        // }

        // if (BARTROLECODE == 'BOMX' || BARTROLECODE == 'BOM' || BARTROLECODE == 'ADMIN') {
        //     if (TICKETSTATUSID == 3) {
        //         $('#voidClosed').show();
        //     }
        // }
    }
}